import { render, staticRenderFns } from "./ReportToken.vue?vue&type=template&id=71dc10a8&"
import script from "./ReportToken.vue?vue&type=script&lang=ts&"
export * from "./ReportToken.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports